module.exports = __webpack_public_path__ + "static/img/servicio1.fd22ac70.jpeg";